module.exports = __webpack_public_path__ + "img/takeaway.573a8804.png";